import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, C, errorMessage } from "../../lib/api";
import { Clock } from "lucide-react";

const mmss = (ms) => { const s = Math.max(0, Math.ceil(ms / 1000)); return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`; };

// Seated before the off: the table waits, chat works, and this counts down to the first deal.
export const MttCountdown = ({ t, seated }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const id = setInterval(() => setNow(Date.now()), 500); return () => clearInterval(id); }, []);
  const nav = useNavigate();
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const left = (t.start_at || 0) - now;
  const unregister = async () => {
    setBusy(true);
    try {
      await api.post(C.ApiRoutes.MTT_UNREGISTER.replace("{event_id}", t.event_id));
      toast.success("Unregistered — you're out of this tournament");
      nav("/lobby");
    } catch (e) { toast.error(errorMessage(e)); setBusy(false); }
  };
  return (
    <div data-testid="mtt-start-countdown" className="absolute inset-x-0 top-[38%] z-30 flex justify-center pointer-events-none rise">
      <div className="glass rounded-2xl border border-amber-300/40 px-10 py-5 text-center shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
        <div className="text-[11px] uppercase tracking-[0.45em] text-amber-200/80 flex items-center justify-center gap-2"><Clock className="w-3.5 h-3.5" /> {t.name}</div>
        {left > 0 ? (<>
          <div className="text-xs text-slate-300 mt-2">Cards are dealt in</div>
          <div data-testid="mtt-start-countdown-clock" className="font-mono text-5xl text-amber-100 tabular-nums mt-1">{mmss(left)}</div>
        </>) : (
          <div className="font-display text-xl text-amber-100 mt-2" data-testid="mtt-start-waiting">Waiting for more players…</div>
        )}
        <div className="text-[11px] text-slate-400 mt-2">{t.entries || 0} registered</div>
        {seated && <div className="mt-3 text-[11px] pointer-events-auto">
          {!ask ? (
            <button data-testid="mtt-countdown-unregister" onClick={() => setAsk(true)} className="text-slate-500 underline underline-offset-2 hover:text-red-300 transition-colors">Unregister</button>
          ) : (
            <span className="flex items-center justify-center gap-3">
              <span className="text-slate-300">Leave this tournament?</span>
              <button data-testid="mtt-countdown-unregister-confirm" disabled={busy} onClick={unregister} className="text-red-300 hover:text-red-200 font-semibold disabled:opacity-60">Yes, unregister</button>
              <button data-testid="mtt-countdown-unregister-cancel" onClick={() => setAsk(false)} className="text-slate-400 hover:text-slate-200">Stay</button>
            </span>
          )}
        </div>}
      </div>
    </div>
  );
};
